/* GS HU: somente textos do Releasit. Carregar após content_for_header,
 * sincronamente antes dos scripts defer do app. Não altera checkout/handlers.
 * Travado no host: enquanto a loja não tiver domínio próprio, só o myshopify
 * da loja HU passa — acrescentar o domínio aqui quando ele existir. */
(function () {
  'use strict';
  var diagnostic = {version: '20261009-1-otv', configPresent: false, applied: 0};
  var host = window.location && window.location.hostname;
  if (host !== 'v2azzi-rj.myshopify.com') return;
  if (window.Shopify && window.Shopify.shop && window.Shopify.shop !== 'v2azzi-rj.myshopify.com') return;
  var config = window._RSI_COD_FORM_SETTINGS;
  if (!config || typeof config !== 'object') { window.GS_HU_RSI_I18N = diagnostic; return; }
  diagnostic.configPresent = true;
  var texts = {
    'OBJEDNEJTE A ZAPLAŤTE PŘI DORUČENÍ': 'RENDELJ ÉS FIZESS ÁTVÉTELKOR',
    'Mezisoučet': 'Részösszeg',
    'Doprava': 'Szállítás',
    'Celková částka k zaplacení': 'Fizetendő teljes összeg',
    'Způsob doručení': 'Szállítási mód',
    'Adj meg egy érvényes kedvezménykódot.': 'Adj meg érvényes kedvezménykódot.',
    'Zadejte prosím platnou e-mailovou adresu.': 'Adj meg érvényes e-mail-címet.',
    'Zadejte prosím platnou hodnotu.': 'Adj meg érvényes értéket.',
    'Apenas 1 desconto por pedido é permitido.': 'Rendelésenként csak egy kedvezmény használható.',
    'Toto pole je povinné.': 'Ez a mező kötelező.',
    'Zdarma': 'Ingyenes',
    'Digite seu endereço de entrega': 'Add meg a szállítási címet',
    'Jméno': 'Keresztnév',
    'Příjmení': 'Vezetéknév',
    'Telefonní číslo': 'Telefonszám',
    'E-mailová adresa': 'E-mail-cím',
    'Zadejte adresu, na které Vás kurýr může zastihnout a doručit zásilku mezi 08:00 a 16:00.': 'Add meg azt a címet, ahol a futár megtalál és 08:00–16:00 között át tudja adni a csomagot.',
    'PSČ': 'Postai irányítószám',
    'Ulice a číslo': 'Utca és házszám',
    'Patro / číslo bytu': 'Emelet / lakás száma',
    'Kraj': 'Megye',
    'Město / Obec': 'Város / Település',
    'Order note': 'Megjegyzés a rendeléshez',
    'Subscribe to stay updated with new products and offers!': 'Iratkozz fel, hogy értesülj az új termékekről és ajánlatokról!',
    'Accept our <a href="/policies/terms-of-service">terms and conditions</a>': 'Elfogadom az <a href="/policies/terms-of-service">általános szerződési feltételeket</a>',
    'nebo': 'vagy',
    '20% sleva': '20% kedvezmény',
    'Zaplaťte online': 'Fizetés online',
    'Todos os impostos incluídos.': 'Minden adó benne van.',
    'Kedvezménykód': 'Kedvezménykód',
    'Descontos': 'Kedvezmények',
    'Aplicar': 'Alkalmaz',
    'K Vaší objednávce jste získali exkluzivní dárek.': 'A rendeléshez különleges ajándékot adunk.',
    'Doprava zdarma': 'Ingyenes szállítás',
    'Default rate': 'Normál szállítási díj',
    'Expresní doručení': 'Expressz szállítás',
    'Taxa de pagamento na entrega': 'Utánvét díja',
    'Add {product_name} to your order!': 'Add a(z) {product_name} terméket a rendeléshez!',
    'Add to my order': 'Hozzáadás a rendeléshez',
    'No thank you, complete my order': 'Nem, köszönöm. Rendelés befejezése',
    'A new code was sent via SMS to your phone number {phone_number}. Enter the code above.': 'Az új kódot SMS-ben elküldtük a(z) {phone_number} számra. Írd be fentebb.',
    'Verify': 'Ellenőrzés',
    'Resend code': 'Kód újraküldése',
    "Didn't receive your code?": 'Nem kaptad meg a kódot?',
    'Change phone number': 'Telefonszám módosítása',
    'You have reached the limit of resends, please try again with a different phone number.': 'Elérted az újraküldési korlátot. Próbáld meg másik telefonszámmal.',
    'Verify your phone number to complete your order': 'Ellenőrizd a telefonszámodat a rendelés befejezéséhez',
    'A verification code was sent via SMS/WhatsApp to your phone number {phone_number}. Enter your code below to verify your phone number:': 'Az ellenőrző kódot SMS-ben/WhatsAppon elküldtük a(z) {phone_number} számra. Írd be alább a telefonszám ellenőrzéséhez:',
    'Your code': 'A kódod',
    'The code you entered is not valid, please try again.': 'A beírt kód érvénytelen. Próbáld újra.',
    'Cash on Delivery is not available for orders above $1000, please use a different payment method.': 'Az utánvétes fizetés nem érhető el 500 000 Ft feletti rendelésekhez. Válassz másik fizetési módot.',
    'Cash on Delivery (COD)': 'Fizetés átvételkor (utánvét)',
    'Poland': 'Magyarország',
    'Hungary': 'Magyarország'
  };
  var groups = ['buyNowButton', 'form', 'messOtp', 'shippingRates', 'codFee', 'upsells', 'visiblity', 'general', 'localization'];
  var skip = {backendFields: true, style: true, titleStyle: true, tracking: true, integrations: true};
  function translate(object) {
    if (!object || typeof object !== 'object') return;
    Object.keys(object).forEach(function (key) {
      if (skip[key]) return;
      var value = object[key];
      if (typeof value === 'string' && Object.prototype.hasOwnProperty.call(texts, value)) {
        object[key] = texts[value]; diagnostic.applied += 1;
      } else if (value && typeof value === 'object') translate(value);
    });
  }
  groups.forEach(function (group) { translate(config[group]); });
  window.GS_HU_RSI_I18N = diagnostic;
})();
